import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import mitt from "mitt";
import alertPlugin from "@/plugins/PopupAlert";
import "@/output.css";
import "@/assets/main.css";
import Antd from 'ant-design-vue'
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css";

const app = createApp(App);
app.config.globalProperties.$eventBus = mitt(); // 將 mitt 實例設置為全局事件總線
app.use(Antd)
app.use(Toast, {
  position: "bottom-center",
  timeout: 3000,
})
app.use(alertPlugin).use(router).use(createPinia()).mount("#app");
